import { ParameterValidator } from '@mvps-genesis/utilities';

export default class ExitTrigger {

	// define "public" properties
	element;
	dialog;
	redirectUrl;

	constructor(
		element = '.js-exit-trigger',
		{
			message = 'Are you sure you want to exit?',
			redirectUrl = window.location.origin,
			triggerEvent = 'click'
		} = {}
	) {

		// create validator instance
		const validator = new ParameterValidator( this );

		// validate and set properties
		this.element = validator.isElement( 'element', element );
		this.message = validator.isString( 'options.message', message )
		this.redirectUrl = validator.isString( 'options.redirectUrl', redirectUrl );
		this.triggerEvent = validator.isString( 'options.triggerEvent', triggerEvent );

		// bind any events
		this.bindEvents();

	}

	bindEvents() {

		this.element.addEventListener( this.triggerEvent, this.onEvent.bind( this ), false );

	}

	onConfirm() {

		window.location = this.redirectUrl;
	
	}

	onCancel() {

		return false;

	}

	openDialog() {

		this.dialog = window.confirm( this.message );
	
	}

	onEvent( e ) {

		e.preventDefault();

		this.openDialog();

		if ( this.dialog ) {

			this.onConfirm();

		}
		else {

			this.onCancel();

		}

	}


}
